import { Outlet } from 'react-router';

import { appRoutes } from '@clearverify/constants';

import { ReactRouteAccessKey } from 'src/constants/reactRouter';
import {
  VerificationPurposesPage,
  VerifierDetailBillingSettingsClearVerifyAdminManagerPage,
  VerifierDetailCompanyInformationPageClearVerifyAdmin,
  VerifierDetailStaffPageClearVerifyAdmin,
  VerifiersPageClearVerifyAdmin,
} from 'src/pages/verifiers';
import { RouteProps } from 'src/types/router';

import { VerifiersDetailOutlet } from './components';

const ROUTES: RouteProps[] = [
  {
    index: true,
    element: <VerifiersPageClearVerifyAdmin />,
    accessRoles: [ReactRouteAccessKey.hasPlatformRoles],
  },
  {
    path: appRoutes.verifiers.detail.index,
    element: <VerifiersDetailOutlet />,
    childRoutes: [
      {
        path: appRoutes.verifiers.detail.companyInformation,
        element: <VerifierDetailCompanyInformationPageClearVerifyAdmin />,
        accessRoles: [ReactRouteAccessKey.inherit],
      },
      {
        path: appRoutes.verifiers.detail.billingSettings,
        element: <VerifierDetailBillingSettingsClearVerifyAdminManagerPage />,
        accessRoles: [ReactRouteAccessKey.inherit],
      },
      {
        path: appRoutes.verifiers.detail.staff,
        element: <VerifierDetailStaffPageClearVerifyAdmin />,
        accessRoles: [ReactRouteAccessKey.inherit],
      },
      {
        path: appRoutes.verifiers.detail.verificationPurposes,
        element: <VerificationPurposesPage />,
        accessRoles: [ReactRouteAccessKey.inherit],
      },
    ],
    accessRoles: [ReactRouteAccessKey.inherit],
  },
];

export const VERIFIERS_ROUTE: RouteProps = {
  path: appRoutes.verifiers.index,
  element: <Outlet />,
  childRoutes: ROUTES,
  accessRoles: [ReactRouteAccessKey.hasPlatformRoles],
};
